/**
 * @packageDocumentation
 * @module f1/string
 */

export interface List {
  /**
   * A list in HIP is a series of words separated by commas or spaces. Comma is useful with CSV and space is useful for classes
   *
   * @public
   * @function f1.list
   * @param s an string separated by spaces or commas
   * @example
   *
   * ```ts
   * f1.list('a,b,c') === ['a', 'b', 'c']
   * f1.list('a, b, c') === ['a', 'b', 'c']
   * f1.list('pax clr-white') === ['pax', 'clr-white']
   * ```
   */
  (s: string): string[];
}

const splitList = /[\s,]/g;

/**
 * @see List
 */
export default (s: string) => {
  return s.split(splitList).map((s) => s.trim());
};
